exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rulesHeader{background:#ffffff;box-shadow:0px 1px 2px rgba(0,0,0,0.05)}.rulesHeader h2{font-size:20px;color:#265390;font-weight:600;padding:19px 20px;margin:0}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/common/header/header.component.scss
// module id = 1359
// module chunks = 1